import { z } from '@uturn/portal/zod';

const selectableShippingLineSchema = z.object({
	id: z.number(),
	code: z.string(),
	description: z.string(),
	screnabled: z.boolean().optional(),
});

export type SelectableShippingLine = z.infer<
	typeof selectableShippingLineSchema
>;

export const isSelectableShippingLine = (
	data: unknown,
): data is SelectableShippingLine =>
	selectableShippingLineSchema.safeParse(data).success;
